<template>
  <div id="app">
      <welcome-language v-if="!isReady" />
      <router-view v-else />
      <notifications group="app" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import WelcomeLanguage from './layouts/WelcomeLanguage/WelcomeLanguage'

export default {
  name: 'app',
  components: {
    WelcomeLanguage,
  },
  computed: {
    ...mapState('settings', ['selectedLanguage', 'isReady'])
  },
  mounted() {
    this.fetchAllProducts()
    this.fetchAllCategories()
    this.fetchClientSettings()
    this.getAvailableLanguages()
    const queryParams = (new URL(document.location)).searchParams;
    const tableNumber = queryParams.get('table');
    const tableCookie = this.getCookie('table')
    if (tableCookie) {
      this.setIsTable(true)
      this.setTableNumber(tableCookie)
    }
    if (tableNumber) {
      const now = new Date();
      let time = now.getTime();
      time += 3600 * 2000;
      now.setTime(time);
      document.cookie = 
      'table=' + tableNumber + 
      '; expires=' + now.toUTCString() + 
      '; path=/';
      this.setIsTable(true)
      let query = Object.assign({}, this.$route.query);
      delete query.table;
      this.$router.replace({ query });
    }
  },
  methods: {
    ...mapActions('settings', ['getAvailableLanguages', 'setSelectedLanguage', 'fetchClientSettings', 'setIsTable', 'setTableNumber']),
    ...mapActions('products', ['fetchAllProducts', 'fetchAllCategories']),
    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
  }
}
</script>

<style lang="scss">
  @import './assets/css/bootstrap.css';
  @import './assets/css/main.css';

  #app {
    height: 100%;
  }
</style>